<div class="container"
  id="property-edit-notes-grid">

  @if (workflows$ | async; as workflows) {
    @if (workflows.length) {
      <div class="row pt-3">
        <div class="col">
          <table id="property-workflows-grid"
            class="table table-striped">
            <thead>
              <tr>
                <th scope="col">Date</th>
                <th scope="col">Sender</th>
                <th scope="col">Status</th>
                <th scope="col">Comment</th>
              </tr>
            </thead>
            <tbody>
              @for (workflow of workflows; track workflow) {
                <tr>
                  <td class="text-nowrap">{{workflow.info.lastActionInitiated|date:'short'}}</td>
                  <td>{{workflow.info.lastActionInitiatorContactName}}</td>
                  <td class="status">{{workflow.info.propertyWorkflowActionDescription}}</td>
                  <td>{{workflow.comment}}</td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      </div>
    } @else {
      <div class="row">
        <div class="col">
          <div class="alert alert-warning">** No History **</div>
        </div>
      </div>
    }
  }

</div>
